import React from "react";
import LoginWrapper from "../hoc/LoginWrapper";
import deLogo from "../../assets/logo.png";
import Card from "../shared/Card";
import EmailVerify from "./sub-screens/EmailVerify";
import RegisterDetails from "./sub-screens/RegisterDetails";
import { useSearchParams } from "react-router-dom";

const Register = () => {
  const [searchParams] = useSearchParams();
  const emailVerified = searchParams.get("key1") ? true : false;

  React.useEffect(() => {}, []);

  return (
    <Card wMax={emailVerified}>
      {emailVerified ? <RegisterDetails /> : <EmailVerify />}
    </Card>
  );
};

export default LoginWrapper(Register, true);
